<div class="tw-bg-gray-80 tw-rounded-t-6 tw-pt-4 tw-px-4 tw-pb-[38px] tw-font-body tw-text-black tw-text-300 tw-relative tw-transition-all tw-overflow-hidden"
  [ngClass]=" { 'tw-h-[440px]': (activeMargUnit > 0) && !!data?.experimentVariantData?.variant?.uiVariants?.showProductPopup && (data?.bannerData?.variantData?.length < 2) } "
  >
  <!--  active product Image popup-->
  @if (!!activeMargUnit && !!data?.experimentVariantData?.variant?.uiVariants?.showProductPopup) {
    <div (click)="setActiveMargUnit(0)" class="tw-absolute tw-z-50 tw-bg-[rgba(0,0,0,0.7)] tw-inset-0 tw-flex tw-justify-center tw-items-center">
      <!--    image container  -->
      <div  (click)="$event.stopPropagation()" class="tw-pl-2 tw-w-[88px] tw-flex-shrink-0 tw-relative tw-overflow-hidden tw-scale-[3]">
        <img class="tw-w-20"
          [src]='data?.bannerData?.productImage' />
        @if (data?.bannerData?.variantData[(activeMargUnit - 1)]?.margUnit > 1) {
          <div
            class="tw-w-[33px] tw-aspect-square tw-absolute tw-bg-teal-500 tw-text-white tw-font-body tw-rounded-full tw-top-[14px] tw-right-[10px]"
            >
            <p class="tw-font-[700] tw-text-[7px] tw-text-center tw-leading-[0px] tw-mt-[11px] tw-tracking-[-0.56px]">Pack of</p>
            <h1 class="tw-font-[700] tw-text-[19px] tw-text-center">{{data?.bannerData?.variantData[(activeMargUnit - 1)]?.margUnit}}</h1>
          </div>
        }
      </div>
    </div>
  }

  <div class="tw-flex tw-flex-col tw-h-full tw-justify-between">
    <div>
      <div class="tw-flex tw-justify-between tw-items-start">
        <div class="tw-mb-5 tw-mt-0.5 tw-flex-1">
          <p class="tw-font-[700] tw-text-[14px] tw-line-clamp-2 tw-mb-0.5">{{ data?.bannerData?.title }}</p>
          @if (data?.bannerData?.variantData?.length > 1) {
            <p class="tw-text-200 tw-text-gray-400 tw-mb-0" i18n="@@chooseYourVariant">Choose your variant</p>
          }
          @if (data?.bannerData?.variantData?.length < 2) {
            <p class="tw-text-200 tw-text-gray-400 tw-mb-0" i18n="@@selectQuantity">Select quantity</p>
          }
        </div>

        <img class="tw-w-4 tw-h-4 tw-m-0 tw-flex-shrink-0"
          (click)="closeSheet()"
          src="/assets/images/cancel-cross.png" />
      </div>
      @for (eachVariant of data?.bannerData?.variantData; track eachVariant; let i = $index) {
        <div class="tw-flex tw-gap-6 bg-white tw-rounded-[11px] tw-mb-2 tw-overflow-hidden tw-shadow-z4 tw-box-border tw-h-[104px]"
          [ngClass]=" { 'tw-border-teal-400 tw-border-2': eachVariant?.cartQuantity, 'tw-border-transparent': !eachVariant?.cartQuantity, 'tw-h-20': data?.bannerData?.variantData?.length < 2} "
          >
          <!--          images -->
          <div class="tw-flex-shrink-0 tw-relative tw-overflow-hidden"
            [ngClass]="{'tw-flex tw-items-end': data?.bannerData?.variantData?.length < 2}">
            <img class="tw-w-20 tw-h-full"
              (click)="setActiveMargUnit(eachVariant?.margUnit)"
              [src]='data?.bannerData?.productImage' />
            @if ((eachVariant?.margUnit > 1)) {
              <div
                class="tw-w-[33px] tw-aspect-square tw-absolute tw-bg-teal-500 tw-text-white tw-font-body tw-rounded-full tw-top-[12px] tw-right-[4px]"
                >
                <p class="tw-font-[700] tw-text-[7px] tw-text-center tw-leading-[0px] tw-mt-[11px] tw-tracking-[-0.56px] tw-mb-0">Pack of</p>
                <p class="tw-font-[700] tw-text-[19px] tw-text-center tw-mb-0">{{eachVariant?.margUnit}}</p>
              </div>
            }
          </div>
          <!--          main content -->
          <div class="tw-py-[13px] tw-flex-1 tw-flex tw-flex-col tw-justify-end">
            <h2 class="tw-space-x-[3px] tw-h-[26px] tw-flex tw-items-center tw-text-[14px]">
              <span>{{ (eachVariant?.quantity / eachVariant?.margUnit).toFixed(0) }}</span>
              <span>{{ data?.bannerData?.unit }}</span>
              @if(eachVariant?.margUnit > 1){
                <ng-container>
                  <span>x</span>
                  <span>{{ eachVariant?.margUnit }}</span>
                </ng-container>
              }
            </h2>
            @if (data?.bannerData?.variantData?.length > 1) {
              <h3 class="tw-space-x-[3px] tw-text-200 tw-text-gray-400 tw-h-[26px] tw-flex tw-items-center"
                >
                <span>₹{{ eachVariant?.perBottle }}</span>
                <span>/</span>
                <span>{{ eachVariant?.quantityUnit }}</span>
              </h3>
            }
            <h2 class="tw-space-x-[3px] tw-h-[26px] tw-flex tw-items-center tw-text-[14px]">
              <span class="tw-line-through ">₹{{eachVariant?.mrp}}</span>
              <span class="tw-font-[700]">₹{{eachVariant?.price}}</span>
            </h2>
          </div>
          <!--          ctas -->
          <div class="tw-w-[81px] tw-flex-shrink-0">
            <div class="tw-flex tw-flex-col tw-justify-between tw-h-full tw-pb-3.5">
              <div class="tw-bg-orange-100 tw-text-orange-400 tw-w-20 tw-h-6 tw-flex tw-justify-center tw-items-center tw-rounded-bl-2 tw-translate-x-1 tw-text-[12px]">
                <p class="tw-font-[700] tw-text-200 tw-mb-0">{{eachVariant?.offPercentage}}% <span i18n="@@off">Off</span></p>
              </div>
              @if (!eachVariant?.cartQuantity) {
                <div class="tw-w-[63px] tw-h-6 tw-flex tw-justify-center tw-items-center tw-bg-teal-600 tw-text-white tw-text-200 tw-font-[700] tw-rounded-[6px]"  (click)="handleQuantityChange(eachVariant, 'ADD')">
                  <span i18n="@@add">Add</span>
                </div>
              }
              @if (eachVariant?.cartQuantity) {
                <div  class="tw-h-6 tw-w-[63px] tw-border tw-border-teal-600 tw-rounded-[6px] tw-flex tw-justify-between tw-items-center tw-px-2 tw-text-teal-600 tw-text-200 tw-font-bold tw-font-body"
                  >
                  <span class="font-plus-minus"  (click)="handleQuantityChange(eachVariant, 'REMOVE')">-</span>
                  <span>{{ eachVariant?.cartQuantity }}</span>
                  <span class="font-plus-minus" (click)="handleQuantityChange(eachVariant, 'ADD')">+</span>
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (showProceedToBuy) {
      <div class="tw-bg-teal-600 tw-rounded-2 tw-text-white tw-flex tw-justify-center tw-items-center tw-relative shine-button tw-overflow-hidden tw-mt-[18px] tw-py-2.5 tw-px-4 tw-font-body tw-font-[700] tw-text-400"
        (click)="data?.callbacks?.handleProceedToBuy(data?.bannerData?.title)"
        i18n="@@proceedToBuy"
      >Proceed to Buy</div>
    }
  </div>
</div>
